export { default } from './TabProductDetail';